import { __assign, __rest } from "tslib";
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentSuggestions from '../CommentSuggestions';
import CommentSuggestionsV2 from '../../lego/CommentSuggestions';
var EditorView = function (_a) {
    var onSuggestionSelect = _a.onSuggestionSelect, rest = __rest(_a, ["onSuggestionSelect"]);
    var mobileUpdates = useFlag('comment_suggestions_mobile');
    return (React.createElement(CommentBoxLayout, { above: mobileUpdates ? (React.createElement(CommentSuggestionsV2, { onSelect: onSuggestionSelect })) : (React.createElement(CommentSuggestions, { onSelect: onSuggestionSelect })), avatar: React.createElement(CommentBoxAvatar, null), content: React.createElement(CommentBoxEditor, __assign({}, rest)) }));
};
EditorView.displayName = 'EditorView';
export default EditorView;
//# sourceMappingURL=EditorView.js.map